export default __webpack_public_path__ + "static/media/shoppies-logo.728dec56.png";